import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { dLogout } from "../../http";
import { setAuth } from "../../store/auth-slice";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const Admin = () => {
  const [activeLink, setActiveLink] = useState("/home");
  const dispatch = useDispatch();
  const history = useHistory();


  useEffect(() => {
    setActiveLink("/home");
  }, []);

  const logout = async () => {
    await dLogout();
    dispatch(setAuth(null));
    return history.push("/login");
  };

  return (
    <ul className="sidebar-menu">
      <li>
        <NavLink
          className="nav-link"
          to="/home"
          onClick={() => setActiveLink("/home")}
          style={{ color: activeLink === "/home" ? "#44be54" : undefined }}>
          <i className="fas fa-home"></i> <span>Dashboard</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/employees"
          onClick={() => setActiveLink("/employees")}
          style={{
            color: activeLink === "/employees" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-users"></i> <span>Employees</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/leaders"
          onClick={() => setActiveLink("/leaders")}
          style={{ color: activeLink === "/leaders" ? "#44be54" : undefined }}>
          <i className="fas fa-user-friends"></i> <span>Leaders</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/admins"
          onClick={() => setActiveLink("/admins")}
          style={{ color: activeLink === "/admins" ? "#44be54" : undefined }}>
          <i className="fas fa-users-cog"></i> <span>Admins</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/teams"
          onClick={() => setActiveLink("/teams")}
          style={{ color: activeLink === "/teams" ? "#44be54" : undefined }}>
          <i className="fas fa-fire"></i> <span>Teams</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/candidate-sourcing"
          onClick={() => setActiveLink("/candidate-sourcing")}
          style={{ color: activeLink === "/candidate-sourcing" ? "#44be54" : undefined }}>
          <i className="fas fa-search-plus"></i> <span>Candidate Sourcing</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/view-candidates"
          onClick={() => setActiveLink("/view-candidates")}
          style={{ color: activeLink === "/view-candidates" ? "#44be54" : undefined }}>
          <i className="fas fa-fire"></i> <span>Candidates</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/attendance"
          onClick={() => setActiveLink("/attendance")}
          style={{
            color: activeLink === "/attendance" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-user"></i> <span>Attendance</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/attendance-summary"
          onClick={() => setActiveLink("/attendance-summary")}
          style={{
            color: activeLink === "/attendance-summary" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-pen"></i> <span >Attendance Summary</span>
        </NavLink>
      </li>



      <li>
        <NavLink
          className="nav-link"
          to="/leaves"
          onClick={() => setActiveLink("/leaves")}
          style={{ color: activeLink === "/leaves" ? "#44be54" : undefined }}>
          <i className="fas fa-book"></i> <span>Leaves</span>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          className="nav-link"
          to="/leaves-management"
          onClick={() => setActiveLink("/leaves-management")}
          style={{ color: activeLink === "/leaves-management" ? "#44be54" : undefined }}>
          <i className="fas fa-house"></i> <span>Leave Management</span>
        </NavLink>
      </li> */}
      <li>
        <NavLink
          className="nav-link"
          to="/assignSalary"
          onClick={() => setActiveLink("/assignSalary")}
          style={{
            color: activeLink === "/assignSalary" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-pen"></i> <span>Assign Salary</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="nav-link"
          to="/salaries"
          onClick={() => setActiveLink("/salaries")}
          style={{ color: activeLink === "/salaries" ? "#44be54" : undefined }}>
          <i className="fas fa-piggy-bank"></i> <span>Salaries</span>
        </NavLink>
      </li>

      <li>
        <NavLink
          className="nav-link"
          to="/notice"
          onClick={() => setActiveLink("/notice")}
          style={{ color: activeLink === "/notice" ? "#44be54" : undefined }}>
          <i className="fas fa-paper-plane"></i> <span>Send Notice</span>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          className="nav-link"
          to="/intern-reports"
          onClick={() => setActiveLink("/intern-reports")}
          style={{
            color: activeLink === "/intern-reports" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-file-alt"></i> <span>Intern Reports</span>
        </NavLink>
      </li> */}
      {/* <li>
        <NavLink
          className="nav-link"
          to="/create-job"
          onClick={() => setActiveLink("/create-job")}
          style={{
            color: activeLink === "/create-job" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-file-alt"></i> <span>Create Job</span>
        </NavLink>
      </li> */}
      {/* <li>
        <NavLink
          className="nav-link"
          to="/view-jobs"
          onClick={() => setActiveLink("/view-jobs")}
          style={{
            color: activeLink === "/view-jobs" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-list"></i> <span>View Jobs</span>
        </NavLink>
      </li> */}



      <li className="menu-header">Starter</li>
      <li>
        <NavLink
          className="nav-link"
          to="/adduser"
          onClick={() => setActiveLink("/adduser")}
          style={{ color: activeLink === "/adduser" ? "#44be54" : undefined }}>
          <i className="fas fa-user-plus"></i> <span>Add User</span>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          className="nav-link"
          to="/create-cand"
          onClick={() => setActiveLink("/create-cand")}
          style={{
            color: activeLink === "/create-cand" ? "#44be54" : undefined,
          }}>
          <i className="fas fa-list"></i> <span>Create Candidate</span>
        </NavLink>
      </li> */}
      <li>
        <NavLink
          className="nav-link"
          to="/addteam"
          onClick={() => setActiveLink("/addteam")}
          style={{ color: activeLink === "/addteam" ? "#44be54" : undefined }}>
          <i className="fas fa-address-card"></i> <span>Add Team</span>
        </NavLink>
      </li>

      <li className="menu-header">Settings</li>
      {/* <li>
        <NavLink
          className="nav-link"
          to="/contact"
          onClick={() => setActiveLink("/contact")}
          style={{ color: activeLink === "/contact" ? "#44be54" : undefined }}
        >
          <i className="fab fa-teamspeak"></i> <span>Contact Us</span>
        </NavLink>
      </li> */}
      <li>
        <NavLink onClick={logout} className="nav-link" to="/home">
          <i className="fas fa-sign-out-alt"></i> <span>Logout</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default Admin;
